// utils/downloadPdf.js
export const downloadPdf = async ({ apiUrl, action, loginCode, date, fallbackFilename = 'Document.pdf' }) => {
  try {
    const res = await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action,
        login_code: loginCode,
        date
      })
    });

    if (!res.ok) {
      console.error('[downloadPdf] HTTPエラー:', res.status, res.statusText);
      throw new Error('HTTPエラー');
    }

    const contentType = res.headers.get('Content-Type') || '';
    if (contentType.includes('application/json')) {
      // Lambdaが base64 + headers を JSONで返した形式の場合
      const data = await res.json();
      if (!data.body) throw new Error('PDFデータが空です');

      const byteCharacters = atob(data.body);
      const byteArray = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
      }
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const disposition = data.headers?.['Content-Disposition'] || data.headers?.['content-disposition'];
      const filename = disposition?.match(/filename="?([^"]+)"?$/)?.[1] || fallbackFilename;

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // Lambdaが application/pdf を直接返した形式
      const blob = await res.blob();
      const contentDisposition = res.headers.get('Content-Disposition') || res.headers.get('content-disposition');
      const filename = contentDisposition?.match(/filename="?([^"]+)"?$/)?.[1] || fallbackFilename;

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (err) {
    console.error('[PDFダウンロードエラー]', err);
    alert('PDFの取得またはダウンロードに失敗しました');
  }
};
